import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEmailmarketingApiV1AccountDetailsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/account-details',
        destPath: '/v1/account-details',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/email-marketing/v1/account-details',
        destPath: '/v1/account-details',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/email-marketing/v1/account-details',
        destPath: '/v1/account-details',
      },
    ],
    _: [
      {
        srcPath: '/email-marketing/v1/account-details',
        destPath: '/v1/account-details',
      },
    ],
    'payments.base44.com': [
      {
        srcPath: '/_api/shoutout/v1/account-details',
        destPath: '/v1/account-details',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_email-marketing_account-details';

/** Retrieves email marketing account details. */
export function get(payload: object): RequestOptionsFactory<any> {
  function __get({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.account_details',
      method: 'GET' as any,
      methodFqn: 'wix.emailmarketing.api.v1.AccountDetailsService.Get',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1AccountDetailsServiceUrl({
        protoPath: '/v1/account-details',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'accountDetails.quotaPeriod.dateFrom' },
              { path: 'accountDetails.quotaPeriod.dateTo' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __get;
}
